
<div class="claims-wrapper">
  <div class="claims-header" (click)="goBack()">
    <img src="../../../../assets/images/arrow-right.png" alt="" />
    Help Center
  </div>
  <div class="contact-us-wrapper claims-body">
    <!-- end row -->
    <div class="row">
      <div class="card w-100">
        <div class="row" style="justify-content: space-between;">
          <div class="col-md-4">
            <div class="contact-info-wrapper">
              <div>
                <div class="contactus">Contact Us</div>
                <h3 class="left-headings">Write To Us At (Correspondence Only)</h3>
                <address>
                  Indusind General Insurance, Healthcare, <br />
                  No.1-89/3/B/40 to 42/KS/301, 3rd floor, <br />
                  Krishe Block, Krishe Sapphire, Madhapur, <br />
                  Hyderabad-Telangana-500081
                </address>
              </div>
              <div>
                <h3 class="left-headings">Email Us</h3>
                <a href="mailto:gigclaims@indusindinsurance.com">gigclaims@indusindinsurance.com</a>
              </div><br />
              <div>
                <h3 class="left-headings">Call Center Number</h3>
                <p>Indusind General Insurance (IGI) : +91 22 48903009</p>
              </div>
            </div>
          </div>
          <div class="col-md-8 p-0">
            <div class="contactus">Facing any Queries?
              <div>Fill the form and let us help you </div>

            </div>

            <form [formGroup]="form">
              <div class="form-group contact-form-wrapper">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Name<sup>*</sup></label>
                    <input class="form-control" type="text" formControlName="name" placeholder="Enter your full name"/>
                    <span class="error-msg small"
                      *ngIf="form.get('name').dirty && form.get('name').status === 'INVALID'">Invalid Name
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Number<sup>*</sup></label>
                    <input class="form-control" type="text" formControlName="number"  placeholder="Enter your mobile number"/>
                    <span class="error-msg small"
                      *ngIf="form.get('number').dirty && form.get('number').status === 'INVALID'">Invalid Mobile Number
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Email<sup>*</sup></label>
                    <input class="form-control" type="text" formControlName="emailBeforeEncrypt" placeholder="Enter your email address"/>
                    <span class="error-msg small"
                      *ngIf="form.get('emailBeforeEncrypt').dirty && form.get('emailBeforeEncrypt').status === 'INVALID'">Invalid
                      Email
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Message<sup>*</sup></label>
                    <textarea required="" class="form-control" formControlName="message" rows="3" placeholder="Describe your query or concern (max 250 characters)"></textarea>
                    <span class="error-msg small"
                      *ngIf="form.get('message').dirty && form.get('message').status === 'INVALID'">Invalid Message
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="spinner-border text-primary mr-3" [hidden]="!isLoading" *ngIf="isLoading"></div>
                  <button class="btn btn-primary mt-1 w-100" [disabled]="!form.valid || isLoading" [hidden]="isLoading"
                    (click)="emailSubmit()">
                    Submit Request
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
  <app-faq></app-faq>
</div>
